import React from 'react';
import { BuildingStorefrontIcon } from '@heroicons/react/24/outline';
import { Button } from '../UI';

interface Props {
    // Overrides the default heading/body for page-specific wording.
    title?: string;
    description?: string;
}

// #region ConnectShopifyEmptyState
/**
 * Rendered in place of a Shopify-backed page's body when the brand has no
 * storefront connected. Reaching such a route by URL must explain the gap, not
 * crash or show an empty table.
 */
export const ConnectShopifyEmptyState: React.FunctionComponent<Props> = ({
    title = 'Connect your Shopify store',
    description = 'This screen works with products and orders from a connected Shopify storefront. Connect a store to use it.',
}): React.ReactElement => {
    return (
        <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-gray-300 dark:border-stone-700 bg-surface px-6 py-16 text-center">
            <BuildingStorefrontIcon className="h-12 w-12 text-gray-400 dark:text-stone-500" aria-hidden="true" />
            <h2 className="mt-4 text-lg font-semibold text-gray-900 dark:text-gray-100">{title}</h2>
            <p className="mt-2 max-w-md text-sm text-gray-600 dark:text-gray-300">{description}</p>
            <div className="mt-6">
                <Button
                    href="/settings?tab=channels"
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    onClick={() => { }}
                >
                    Connect Shopify
                </Button>
            </div>
            <p className="mt-4 max-w-md text-xs text-gray-500 dark:text-gray-400">
                You can keep creating and licensing designs without a store — licensing lives under Product Listing.
            </p>
        </div>
    );
};

export default ConnectShopifyEmptyState;
